module.exports = __webpack_public_path__ + "img/nlgc3.b77fc5e2.jpeg";